/* oluxa-shop.js — Announcement · View toggle · Sort · Wishlist · Quick-view · Toast · Mobile FAB */
(function () {
  'use strict';

  function init() {

    /* ===== Mobile floating menu (inject + toggle) ===== */
    if (!document.querySelector('.ox-mobile-fab')) {
      var fab = document.createElement('button');
      fab.type = 'button';
      fab.className = 'ox-mobile-fab';
      fab.setAttribute('aria-label', 'Open menu');
      fab.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg>';
      document.body.appendChild(fab);

      var menu = document.createElement('div');
      menu.className = 'ox-mobile-menu';
      menu.innerHTML =
        '<div class="ox-mobile-menu__head">Oluxa</div>' +
        '<a href="/">Home</a>' +
        '<a href="/collections/all">Shop</a>' +
        '<a href="/pages/about">About</a>' +
        '<a href="/pages/track-order">Track Order</a>' +
        '<a href="/blogs/journal">Journal</a>' +
        '<a href="/pages/contact">Contact</a>' +
        '<button type="button" class="ox-mobile-menu__close" aria-label="Close menu"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 5l14 14M19 5L5 19"/></svg></button>';
      document.body.appendChild(menu);

      fab.addEventListener('click', function () {
        menu.classList.add('ox-mobile-menu--open');
        document.body.style.overflow = 'hidden';
      });
      var closeBtn = menu.querySelector('.ox-mobile-menu__close');
      if (closeBtn) closeBtn.addEventListener('click', function () {
        menu.classList.remove('ox-mobile-menu--open');
        document.body.style.overflow = '';
      });
      menu.addEventListener('click', function (e) {
        if (e.target.tagName === 'A') {
          menu.classList.remove('ox-mobile-menu--open');
          document.body.style.overflow = '';
        }
      });
    }

    /* ===== Announcement bar rotation ===== */
    var msgs = document.querySelectorAll('.ox-announcement__msg-item');
    var btnPrev = document.querySelector('.ox-announcement__btn--prev');
    var btnNext = document.querySelector('.ox-announcement__btn--next');
    var msgEl   = document.querySelector('.ox-announcement__msg');
    var current = 0;

    function showMsg(idx) {
      if (!msgEl || !msgs.length) return;
      current = ((idx % msgs.length) + msgs.length) % msgs.length;
      msgEl.className = 'ox-announcement__msg';
      void msgEl.offsetWidth;
      msgEl.className = 'ox-announcement__msg';
      msgEl.textContent = msgs[current] ? msgs[current].textContent : '';
    }

    if (msgEl && msgs.length) {
      showMsg(0);
      var timer = setInterval(function () { showMsg(current + 1); }, 4200);
      if (btnPrev) btnPrev.addEventListener('click', function () { clearInterval(timer); showMsg(current - 1); timer = setInterval(function () { showMsg(current + 1); }, 4200); });
      if (btnNext) btnNext.addEventListener('click', function () { clearInterval(timer); showMsg(current + 1); timer = setInterval(function () { showMsg(current + 1); }, 4200); });
    }

    /* ===== View toggle (grid / list) ===== */
    var gridBtn  = document.querySelector('.ox-filter__view-btn[data-view="grid"]');
    var listBtn  = document.querySelector('.ox-filter__view-btn[data-view="list"]');
    var gridWrap = document.querySelector('.ox-product-grid');
    var listWrap = document.querySelector('.ox-product-list');

    function applyView(v) {
      if (!gridWrap || !listWrap) return;
      if (v === 'grid') {
        gridWrap.classList.remove('ox-hidden');
        listWrap.classList.add('ox-hidden');
        if (gridBtn) gridBtn.classList.add('ox-filter__view-btn--active');
        if (listBtn) listBtn.classList.remove('ox-filter__view-btn--active');
      } else {
        listWrap.classList.remove('ox-hidden');
        gridWrap.classList.add('ox-hidden');
        if (listBtn) listBtn.classList.add('ox-filter__view-btn--active');
        if (gridBtn) gridBtn.classList.remove('ox-filter__view-btn--active');
      }
      try { localStorage.setItem('oluxa-view', v); } catch(e) {}
    }

    var savedView = 'grid';
    try { savedView = localStorage.getItem('oluxa-view') || 'grid'; } catch(e) {}
    applyView(savedView);

    if (gridBtn) gridBtn.addEventListener('click', function () { applyView('grid'); });
    if (listBtn) listBtn.addEventListener('click', function () { applyView('list'); });

    /* ===== Sort select ===== */
    var sortSel = document.querySelector('.ox-filter__select');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        var map = { 'featured': 'manual', 'newest': 'created-descending', 'price-asc': 'price-ascending', 'price-desc': 'price-descending' };
        url.searchParams.set('sort_by', map[sortSel.value] || sortSel.value);
        window.location.href = url.toString();
      });
    }

    /* ===== Wishlist ===== */
    var WL_KEY = 'oluxa-wishlist';
    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch(e) { return []; }
    }
    function saveWishlist(arr) {
      try { localStorage.setItem(WL_KEY, JSON.stringify(arr)); } catch(e) {}
    }
    function applyWishlistUI() {
      var wl = getWishlist();
      document.querySelectorAll('[data-wish-id]').forEach(function (btn) {
        var id = btn.dataset.wishId;
        var wished = wl.indexOf(id) > -1;
        btn.classList.toggle('ox-card__action-btn--wished', wished);
        btn.classList.toggle('ox-list-card__wish--wished', wished);
        var svg = btn.querySelector('svg');
        if (svg) svg.setAttribute('fill', wished ? 'currentColor' : 'none');
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wish-id]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.dataset.wishId;
      var wl = getWishlist();
      var idx = wl.indexOf(id);
      if (idx > -1) wl.splice(idx, 1);
      else wl.push(id);
      saveWishlist(wl);
      applyWishlistUI();
    });
    applyWishlistUI();

    /* ===== Toast ===== */
    var toastEl = document.getElementById('ox-toast');
    var toastTimer;
    window.oxShowToast = function (msg) {
      if (!toastEl) return;
      var m = toastEl.querySelector('.ox-toast__msg');
      if (m) m.textContent = msg;
      toastEl.classList.add('ox-toast--show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('ox-toast--show'); }, 2400);
    };

    /* ===== Quick-view ===== */
    var qvScrim = document.getElementById('ox-qv-scrim');
    var qvCloseBtn = document.getElementById('ox-qv-close');
    function closeQV() {
      if (qvScrim) qvScrim.classList.remove('ox-qv-scrim--open');
      document.body.style.overflow = '';
    }
    if (qvScrim) {
      qvScrim.addEventListener('click', function (e) { if (e.target === qvScrim) closeQV(); });
    }
    if (qvCloseBtn) qvCloseBtn.addEventListener('click', closeQV);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-id]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var productUrl = btn.dataset.quickUrl;
      openQuickView(productUrl);
    });

    function openQuickView(url) {
      if (!qvScrim || !url) return;
      fetch(url + '.js')
        .then(function (r) { return r.json(); })
        .then(function (prod) {
          populateQV(prod);
          qvScrim.classList.add('ox-qv-scrim--open');
          document.body.style.overflow = 'hidden';
        })
        .catch(function () { window.location.href = url; });
    }

    function populateQV(prod) {
      var variant = prod.variants[0];
      var price    = (variant.price / 100).toFixed(2);
      var compare  = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;
      var savings  = compare ? ((variant.compare_at_price - variant.price) / 100).toFixed(2) : null;

      var set = function (sel, txt) {
        var el = document.querySelector(sel);
        if (el) el.textContent = txt;
      };

      set('.ox-qv-panel__tag',  prod.tags.join(' · '));
      set('.ox-qv-panel__name', prod.title);
      set('.ox-qv-panel__sub',  variant.title !== 'Default Title' ? variant.title : '');
      set('.ox-qv-panel__price', '$' + price);
      var strikeEl = document.querySelector('.ox-qv-panel__strike');
      var saveEl   = document.querySelector('.ox-qv-panel__save');
      if (compare) {
        if (strikeEl) { strikeEl.textContent = '$' + compare; strikeEl.style.display = ''; }
        if (saveEl)   { saveEl.textContent = 'Save $' + savings; saveEl.style.display = ''; }
      } else {
        if (strikeEl) strikeEl.style.display = 'none';
        if (saveEl)   saveEl.style.display = 'none';
      }

      var qvImg = document.querySelector('.ox-qv-panel__img img');
      if (qvImg && prod.images && prod.images[0]) {
        qvImg.src = prod.images[0].src.replace(/(\.[a-z]+)$/, '_920x$1');
        qvImg.alt = prod.title;
      }

      var addBtn = document.getElementById('ox-qv-add-btn');
      if (addBtn) {
        addBtn.textContent = 'Add to bag — $' + price;
        addBtn.dataset.variantId = variant.id;
      }
    }

    var qvAddBtn = document.getElementById('ox-qv-add-btn');
    if (qvAddBtn) {
      qvAddBtn.addEventListener('click', function () {
        var variantId = parseInt(qvAddBtn.dataset.variantId, 10);
        if (!variantId) return;
        if (window.oxCartAdd) {
          window.oxCartAdd(variantId, 1, function () {
            closeQV();
            if (window.oxShowToast) window.oxShowToast('Added');
            setTimeout(function () { if (window.oxCartOpen) window.oxCartOpen(); }, 200);
          });
        }
      });
    }

    /* ===== Escape closes overlays ===== */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeQV();
        var cartScrim = document.getElementById('ox-cart-scrim');
        if (cartScrim && cartScrim.classList.contains('ox-cart-scrim--open')) {
          if (window.oxCartClose) window.oxCartClose();
        }
        var mobMenu = document.querySelector('.ox-mobile-menu--open');
        if (mobMenu) { mobMenu.classList.remove('ox-mobile-menu--open'); document.body.style.overflow = ''; }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();